import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/date-fns/esm/startOfWeek/index.js';

var require$$41 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$41 as default };
